"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "val-di-zoldo": {
    "58d99548": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "astragal": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "507c150d": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "bragarezza": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6907b72": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "calchera": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fe66ba0": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "campo": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fdead20e": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "casal": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6579bcaa": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "cella": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d663498c": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "cordelle": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a151a15": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "dozza": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3acb785c": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "foppa": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca1698ba": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "iral": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82afa5b2": [{
      "hkey": "118e59d3",
      "slug": "mareson-pecol",
      "name": "Mareson-Pecol",
      "primary": true,
      "skipSearch": false
    }],
    "mareson": [{
      "hkey": "118e59d3",
      "slug": "mareson-pecol",
      "name": "Mareson-Pecol",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "deae3a3f": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "molin": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2bc9e50": [{
      "hkey": "118e59d3",
      "slug": "mareson-pecol",
      "name": "Mareson-Pecol",
      "primary": true,
      "skipSearch": false
    }],
    "pecol": [{
      "hkey": "118e59d3",
      "slug": "mareson-pecol",
      "name": "Mareson-Pecol",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "val-di-zoldo"
    }],
    "77a2c6de": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "pra": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a40b330b": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "sommariva": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2c523f8": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "sorogno": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9d0066a": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd5c6cd9": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "skipSearch": false
    }],
    "zoldo-alto": [{
      "hkey": "d02f4b7a",
      "slug": "val-di-zoldo",
      "name": "Val di Zoldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;